import React from "react";
import MyCalendar, { ViewType } from "./Calendar";
import Footer from "./Footer";
import Header from "./Header";

/* https://calendar-react.com  */

function Home() {
  const [currentView, setCurrentView] = React.useState<ViewType>(() => {
    const savedView = localStorage.getItem('calendarView');
    return (savedView === 'MONTH' || savedView === 'WEEK' || savedView === 'DAY') ? savedView as ViewType : 'MONTH';
  });
  const [data, setData] = React.useState<any[]>([]);
  const [selectedEvent, setSelectedEvent] = React.useState<any>(null);
  const [refreshTrigger, setRefreshTrigger] = React.useState(0);
  const [pushEnabled, setPushEnabled] = React.useState(false);
  const [showSchulferien, setShowSchulferien] = React.useState(() => {
    const saved = localStorage.getItem('showSchulferien');
    return saved === 'true';
  });

  const handleEventClick = React.useCallback((event: any) => {
    setSelectedEvent(event);
  }, []);

  const handleImportSuccess = React.useCallback(() => {
    setRefreshTrigger(prev => prev + 1);
  }, []);

  const handleDataChange = React.useCallback((newData: any[]) => {
    setData(newData);
  }, []);

  const handleSearchEventHandled = React.useCallback(() => {
    setSelectedEvent(null);
  }, []);

  return (
    <div className="home-layout">
      <Header 
        currentView={currentView} 
        setCurrentView={setCurrentView}
        data={data}
        onEventClick={handleEventClick}
        onImportSuccess={handleImportSuccess}
        pushEnabled={pushEnabled}
        setPushEnabled={setPushEnabled}
        showSchulferien={showSchulferien}
        setShowSchulferien={setShowSchulferien}
      />
      <div className="main-content">
        <div className="calendar-wrapper">
          <MyCalendar 
            currentView={currentView} 
            setCurrentView={setCurrentView}
            onDataChange={handleDataChange}
            searchSelectedEvent={selectedEvent}
            onSearchEventHandled={handleSearchEventHandled}
            refreshTrigger={refreshTrigger}
            showSchulferien={showSchulferien}
          />
        </div>
      </div>
     
      <Footer />
      
    </div>
  );
}

export default Home;
